import styled from 'styled-components';

const FormHeading = styled.div`
display: flex;
width: 100%;
background: #fff;
${'' /* border-radius:6px; */}
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 700;
line-height: 24px; /* 133.333% */
color: ${({ color }) => color ? color : '#184A61'};
height:56px;
padding-left:0px;
align-items: center;
margin-bottom: 25px;

border-radius: 12px;
border: 0.75px solid var(--Bg-Color-for-Light-theme-300, #DCDCDC);

.close-icon{
    margin:0px 8px;
    cursor:pointer;
}
.end-card{
  display:flex;
  margin: auto 0 auto auto;
}
`;

const DateCard = styled.div`
display: flex;
width: 100%;
border: 1px solid #BDBDBD;
border-radius:4px;
color: ${({ color }) => color ? '#BDBDBD' : '#184A61'};
background: ${({ background }) => background ? '#EFEFEF' : 'transparent'};
font-family: Lato;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 20px;
padding: 14px 16px;
justify-content: space-between;
align-items: center;
>svg{
  cursor:pointer;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
}
`;

const DateCardWrapper = styled.div`
display:flex;
gap:8px;
width:100%;
.startDate{
  width:450px;
  display:flex;
}
.endDate{
  width:450px;
  display:flex;
}
`;

export { FormHeading, DateCard, DateCardWrapper }